/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyResponseModel } from '../../models/client-survey-response-model';

export interface GetSurveyResponse$Plain$Params {

/**
 * id of surveyresponse for filter
 */
  surveyResponseId: number;
}

export function getSurveyResponse$Plain(http: HttpClient, rootUrl: string, params: GetSurveyResponse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyResponse$Plain.PATH, 'get');
  if (params) {
    rb.path('surveyResponseId', params.surveyResponseId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyResponseModel>;
    })
  );
}

getSurveyResponse$Plain.PATH = '/api/SurveyResponse/{surveyResponseId}';
